/*
 * @Author: xiaolong.xu
 * @Date: 2023-10-24 17:43:43
 * @LastEditors: 最后编辑
 * @LastEditTime: 2023-10-25 20:24:21
 * @Description: file content
 */
import React from 'react'
import { useRouter } from 'next/router'
import { useTranslation } from '@/libs/next-lang'
import { HOME_PATH } from '@/constants'
import useInquiryModal from '@/page-components/components/LeadGeneration/useInquiryModal'
import styles from './index.module.less'

const LeadGeneration = React.memo(() => {
  const { t } = useTranslation(['components'])
  const { showModal: showInquiryModal, render: renderInquiryModal } = useInquiryModal()

  // 需要显示的页面
  const router = useRouter()
  const { pathname } = router
  // 判断是否匹配/template路径
  const isShow =
    pathname === HOME_PATH ||
    pathname.startsWith('/inspiration/case') ||
    pathname.startsWith('/inspiration/template') ||
    pathname.startsWith('/creative/mall')

  if (isShow) {
    return (
      <>
        <div className={styles['lead-generation']} onClick={() => showInquiryModal()}>
          <div>{t('components:t128')}</div>
          <div>{t('components:t129')}</div>
        </div>
        {renderInquiryModal()}
      </>
    )
  }
  return null
})

export default LeadGeneration
